import React, { Component, ReactNode } from 'react';
import { Modal, ModalType } from '@code/innovance-react-ui-kit';

interface State {
  showError: boolean;
  error?: Error | null | undefined;
  errorInfo?: React.ErrorInfo;
}

class ErrorBoundary extends Component<{}, State> {
  constructor(props: {}) {
    super(props);
    this.state = {
      showError: false,
      error: null,
    };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    this.setState({ showError: true, error });
  }

  handleModalClose = (): void => {
    this.setState({ showError: false });
  };

  render(): ReactNode {
    const { children } = this.props;
    const { showError, error } = this.state;

    return (
      <>
        {showError ? (
          <Modal
            description={error?.message || ''}
            onCancel={this.handleModalClose}
            submitText="OK"
            title="Error"
            type={ModalType.Error}
          />
        ) : null}
        {children}
      </>
    );
  }
}

export default ErrorBoundary;
